import React from "react";
import Header from "../components/common/Header";
import HomePoster from "../components/home/HomePoster";

const HomePage = () => {
  return (
    <>
      <Header></Header>
      <HomePoster></HomePoster>
    </>
  );
};

export default HomePage;
